import { useState } from "react";
import { groupBy, isFunction } from "lodash";

export const useSearchOptions = <Option = unknown>(
  options: Option[] | readonly Option[],
  filterBy: (options: Option[] | readonly Option[], search: string) => Option[],
  groupByValue?: (option: Option) => string | undefined,
  onSearchChange?: (value: string) => void,
) => {
  const [search, setSearch] = useState("");
  const clearSearch = () => setSearch("");

  const handleSearchChange = (value: string) => {
    setSearch(value);
    onSearchChange?.(value);
  };

  const searchResults = filterBy(options, search);

  const hasNoResults =
    (searchResults.length === 0 && search !== "") || options.length === 0;

  const shouldGroup = isFunction(groupByValue) && !hasNoResults;

  const groupedSearchResults = shouldGroup
    ? groupBy(searchResults, groupByValue)
    : null;

  const hasGroups = Boolean(
    groupedSearchResults && Object.keys(groupedSearchResults).length > 0,
  );

  return {
    search,
    clearSearch,
    handleSearchChange,
    searchResults,
    hasNoResults,
    groupedSearchResults,
    hasGroups,
  };
};
